var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F5E4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_3238)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.988,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9857 8.30772C21.9857 8.90342 21.9857 9.49913 21.9857 10.0948C21.9517 11.4475 21.9176 12.8049 21.8831 14.1671C21.7434 14.5077 21.5041 14.6005 21.1654 14.4454C20.7503 14.0304 20.3353 13.6153 19.9202 13.2003C17.7466 15.3837 15.564 17.5566 13.3724 19.7189C13.1902 19.8176 13.0144 19.8078 12.845 19.6896C12.0003 18.8448 11.1556 18.0001 10.3109 17.1554C10.1762 16.9291 10.1957 16.7143 10.3695 16.5108C12.513 14.3673 14.6566 12.2237 16.8001 10.0802C16.3851 9.66514 15.9701 9.25011 15.555 8.83506C15.4006 8.49508 15.4934 8.25582 15.8333 8.11729C17.7861 8.05661 19.7392 8.02731 21.6927 8.0294C21.8251 8.08865 21.9228 8.18142 21.9857 8.30772Z",
    fill: "#6A097D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41699 17.5357C9.77301 17.4886 9.97809 17.64 10.0322 17.9898C10.0227 18.116 9.97879 18.2283 9.90039 18.3267C9.22086 19.016 8.53238 19.6948 7.83496 20.3629C7.43959 20.494 7.20522 20.3572 7.13184 19.9527C7.14133 19.8265 7.18528 19.7142 7.26367 19.6158C7.91309 18.9664 8.5625 18.317 9.21191 17.6676C9.27813 17.6152 9.34649 17.5712 9.41699 17.5357Z",
    fill: "#6A097D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65918 22.9856C7.5127 22.9856 7.36621 22.9856 7.21973 22.9856C7.12069 22.9159 7.04256 22.828 6.98535 22.722C6.98535 22.6145 6.98535 22.5071 6.98535 22.3997C8.13992 21.2012 9.3118 20.0146 10.501 18.8401C10.9034 18.6556 11.1573 18.7777 11.2627 19.2063C11.2464 19.3105 11.2123 19.4081 11.1602 19.4993C9.99625 20.6681 8.82925 21.8302 7.65918 22.9856Z",
    fill: "#6A097D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9071 19.9681C12.3322 19.9591 12.5129 20.1642 12.4491 20.5833C12.4227 20.6586 12.3837 20.727 12.3319 20.7884C11.6825 21.4378 11.0331 22.0872 10.3837 22.7366C10.0674 22.9482 9.80856 22.8945 9.60733 22.5755C9.57025 22.3959 9.59955 22.2298 9.69523 22.0774C10.3544 21.4182 11.0136 20.7591 11.6728 20.0999C11.7489 20.0473 11.827 20.0034 11.9071 19.9681Z",
    fill: "#6A097D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_3238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.8993ad6d60c7f55646f964e66b550c01.svg";
export { ForwardRef as ReactComponent };